import React from 'react';
import { Box, Flex, IconButton, Text, useMediaQuery, VStack } from '@chakra-ui/react';
import { FaBell, FaHome, FaWallet, FaShoppingBasket, FaExchangeAlt, FaUser } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const sampleNotifications = [
    {
      _id: '1',
      subject: 'New Order',
      message: 'You Placed an Order at Restaurant ABC.',
      isRead: false,
    },
    {
      _id: '2',
      subject: 'Payment Received',
      message: 'Payment has been processed for an order.',
      isRead: true,
    },
    {
      _id: '3',
      subject: 'Important Update',
      message: 'There is an important update regarding your Wallet.',
      isRead: false,
    },
  ];

const UserNotifications = () => {
  const [isMobile] = useMediaQuery("(max-width: 768px)");


  return (
    <Box p={4}>
      {!isMobile && (
        <Flex bg="blue.200" p={2} mt={-9} mb={4} align="center" justify="space-between">
        <Link to="/user-home">
        <Text
            size="md"
            fontWeight="semibold"
            color="white"
            _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
        >
            Home
        </Text>
        </Link>
          <Link to="/user-wallet">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Wallet
            </Text>
          </Link>
          <Link to="/user-market">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Market
            </Text>
          </Link>
          <Link to="/user-trades">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Trades
            </Text>
          </Link>
          <Link to="/user-account">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Account
            </Text>
          </Link>          
            <Link to="/user-notifications">        
                <IconButton
                    icon={<FaBell />}
                    variant="ghost"
                    colorScheme="blue"
                    aria-label="Notifications"
                />        
            </Link>    
        </Flex>
      )}

        
{/* Main Content */}
    <Box bg="blue.50" p={4} borderRadius="md" boxShadow="md" w={["100%", "100%", "80%"]} mx="auto">
        <Text fontSize="md" fontWeight="semibold">
            Notifications
        </Text>
        {/* Active Trades Section */}
        <Box bg="white" p={4} borderRadius="md" mb={4} w={["100%", "100%", "70%"]} mx="auto">
            <VStack align="stretch" spacing={4}>
            {sampleNotifications.map((notification) => (
            <Box
                key={notification._id}
                bg="white"
                p={4}
                borderRadius="md"
                boxShadow="md"
            >
                <Text color="blue.200" fontWeight="bold">
                {notification.subject}
                </Text>
                <Text color={notification.isRead ? 'gray.600' : 'black'} fontWeight="medium">
                {notification.message}
                </Text>
            </Box>
            ))}
            </VStack>
        </Box>        
    </Box>    
      {isMobile && (
        <Flex bg="blue.200" p={2} mt={4} align="center" justify="space-between" position="fixed" bottom={0} width="95%">
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-home">
                <Flex alignItems="center" flexDirection="column">
                <FaHome />
                <Text color="white" fontSize="xs" mt={1}>
                    Home
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-wallet">
                <Flex alignItems="center" flexDirection="column">
                <FaWallet />
                <Text color="white" fontSize="xs" mt={1}>
                    Wallet
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-market">
                <Flex alignItems="center" flexDirection="column">
                <FaShoppingBasket />
                <Text color="white" fontSize="xs" mt={1}>
                    Market
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-trades">
                <Flex alignItems="center" flexDirection="column">
                <FaExchangeAlt />
                <Text color="white" fontSize="xs" mt={1}>
                    Trades
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-notifications">
                <Flex alignItems="center" flexDirection="column">
                <FaBell />
                <Text color="white" fontSize="xs" mt={1}>
                    Notifications
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-account">
                <Flex alignItems="center" flexDirection="column">
                <FaUser />
                <Text color="white" fontSize="xs" mt={1}>
                    Account
                </Text>
                </Flex>
            </Link>
            </Box>
        </Flex>
        )}
    </Box>
  );
};

export default UserNotifications;
